import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fade from 'react-reveal/Fade';

import { ThemeContext } from '../../contexts/ThemeContext';

import expImgWhite from '../../assets/svg/experience/expImgWhite.svg'
import expImgBlack from '../../assets/svg/experience/expImgBlack.svg'

import './Experience.css'

function ExperienceCard({id, company, jobtitle, startYear, endYear}) {

    const { theme } = useContext(ThemeContext);

    const useStyles = makeStyles((t) => ({
        experienceCard : {
            backgroundColor:theme.primary30,
            "&:hover": {
                backgroundColor:theme.primary50,
            },
        },
    }));

    const classes = useStyles();


    return (
        <Fade bottom>
            <div key={id} className={`experience-card ${classes.experienceCard}`}>
                <div className="expcard-img" style={{backgroundColor: theme.primary}}>
                    <img src={theme.type === 'light' ? expImgBlack : expImgWhite} alt="" />
                </div>
                <div className="experience-details">
                    <h6 style={{color: theme.primary}}>{startYear}-{endYear}</h6>
                    <h4 style={{color: theme.tertiary}}>{jobtitle}</h4>
                    <h5 style={{color: theme.tertiary80}}>{company}</h5>
                    <ul>
                        <li>Contributed in building logistics platform <b>AX4</b> for clients like BMW, Audi, Ford, Porsche, DHL or Schenker.</li>
                        <li>Worked in agile teams of 5-6 members with highly experienced leaders, quality managers and project manager,
		                    gained expierence in using tools like <b>GitLab</b>, <b>Jira</b>, <b>Confluence</b> and <b>ServiceNow</b>.</li>
                        <li>Took part in development of internal tools gaining profesional experience with <b>Java</b>, <b>Spring</b>, <b>Hibernate</b>, <b>Oracle DB</b>, <b>Gradle</b>, <b>Jenkins</b>, <b>IntelliJ IDEA</b> and <b>GIT</b>.</li>
                        <li>Participated in building bussiness web application using <b>GWT</b>, <b>JavaScript</b>, <b>HTML</b> and <b>CSS</b>.</li>
                        <li>Attended to daily meetings, planning sprints, providing code reviews, writing technical documentations. Expierienced leading meetings and being advisor for trainees.</li>
                    </ul>
                </div>
            </div>
        </Fade>   
    )
}

export default ExperienceCard
